<template>
  <section class="content-max-width site-breadcrumbs">
    <div class="">
      <ul class="breadcrumbs">
        <li v-for="(crumb, index) of crumbs" :key="index">
          <a :href="crumb.url">{{ crumb.title }}</a>
          <span>></span>
        </li>
      </ul>
    </div>
    <!-- <a href="/stories" class="click-here" v-if="pathCount > 2"> Back </a> -->
  </section>
</template>

<script>
export default {
  props: {
    crumbs: Array,
  },
  computed: {
    pathCount() {
      return window.location.pathname.split("/").length;
    },
  },
};
</script>

<style lang="scss">
@import "../../sass/core/variables.scss";

.site-breadcrumbs {
  display: flex;
  justify-content: space-between;
  align-content: center;

  .click-here {
    padding-bottom: 4px;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 28px;
    color: #ec0a28;
    border-bottom: 3px solid #ec0a28;
  }

  margin-top: 19px;

  & + .title-section {
    margin-top: 37px;
  }

  .breadcrumbs {
    margin: 0;
    padding: 0;

    li {
      display: inline-block;
      margin: 0px 15px 0 0;

      font-size: 13px;

      a {
        color: #ec0a28;

        font-size: 18px;
        font-weight: 300;
        letter-spacing: 0;
        line-height: 24px;
      }

      span {
        position: relative;
        top: 1px;
        right: -8px;

        display: inline-block;
        width: 11px;

        color: #231f20;
        font-size: 17px;
      }

      &:last-child {
        a {
          color: #231f20;
        }
        span {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Breadcrumbs.vue